import { Component, OnInit } from '@angular/core';
import { initial } from 'lodash';
import { HttpService } from 'src/app/http.service';

@Component({
  selector: 'app-domain-management',
  templateUrl: './domain-management.component.html',
  styleUrls: ['./domain-management.component.scss']
})
export class DomainManagementComponent {

  public domains: any = [];
  public selected_company: string = '';
  constructor(private http: HttpService) {
    this.selected_company = this.http.getStaticSelectedCompany();
    this.init();
  }

  async init() {
    const rtn: any = await this.http.post("/admin/domain/get");
    console.log(rtn);
    this.domains = rtn;
  }

  async delete(uuid: string) {
    let c = confirm("Are you sure you want to delete this domain? Once this is remove, this could not be recover.");
    if (!c) {
      return;
    }
    const rtn: any = await this.http.post("/admin/domain/delete", { uuid: uuid });
    this.init();
  }
}
